<script>
import Vue from 'vue';
import CellPopover from '~/components/vuetable/components/cell_popover';

export default {
    name: 'cell-popover-list',

    components: {
        CellPopover
    },

    props: {
        placement: {
            type: String,
            default: 'top-start'
        },

        trigger: {
            type: String,
            default: 'hover'
        },

        width: {
            type: String,
            default: '200'
        },

        title: {
            type: String,
            default: null
        },

        content: {
            type: Array,
            default: () => []
        },

        truncate: {
            type: Boolean,
            default: false
        },

        tagType: {
            type: String,
            default: null
        },

        maxShown: {
            type: Number,
            default: 2
        }
    },
    computed: {
        tagClass() {
            return {
                'el-tag m-r-5': true,
                'el-tag--gray': this.tagType === 'gray',
                'el-tag--primary': this.tagType === 'primary',
                'el-tag--success': this.tagType === 'success',
                'el-tag--danger': this.tagType === 'danger',
                'el-tag--warning': this.tagType === 'warning'
            }
        },

        hiddenListCount() {
            return this.content.length - this.maxShown;
        }
    }
}
</script>

<template>
    <div>
        <template v-if="content.length > maxShown">
            <cell-popover>
                <template v-for="value in content">
                    <div>{{value}}</div>
                </template>

                <template slot="reference">
                    <template v-for="(value, index) in content">
                        <template v-if="index < maxShown">
                            <span :class="tagClass" v-if="value">{{value}}</span>
                        </template>
                    </template>

                    <template v-if="content.length > maxShown">
                        <span :class="tagClass">
                            + {{hiddenListCount}}
                        </span>
                    </template>
                </template>
            </cell-popover>
        </template>

        <template v-else>
            <template v-for="(value, index) in content">
                <span :class="tagClass" v-if="value">{{value}}</span>
            </template>
        </template>
    </div>
</template>